module.exports = __webpack_public_path__ + "u5.no2.052c2fc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u5.no2.jpg
// module id = z5fp
// module chunks = 0